export default "__VITE_ASSET__B$guDC_r__"